module.exports = __webpack_public_path__ + "static/img/1636098f00e133c6569c14917f86857a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs.png
// module id = XiYv
// module chunks = 1